/* 상품 상세 이미지 핀치 줌 — 모바일 전용.
 *
 * ⚠️⚠️ **페이지가 아니라 이미지만 커져야 한다.** 브라우저 기본 핀치는 뷰포트를 확대하므로
 *    `touch-action: none`(CSS 의 `.nt-pz-on`)으로 그 제스처를 가져오고, iOS Safari 는
 *    거기에 더해 `gesturestart` 를 막아야 페이지 줌이 안 걸린다.
 * ⚠️ 평소에는 `touch-action: pan-y` 라 **세로 스크롤은 브라우저 몫**이다 — 여기서 다 가로채면
 *    이미지 위에서 페이지가 안 내려간다.
 * ⚠️ 확대 중에는 슬라이더로 이벤트를 넘기지 않는다(`stopPropagation`). 안 그러면 그림을 끌어
 *    옮기려는 손짓이 **다음 슬라이드로 넘긴다**.
 * ⚠️ 배율이 1 로 돌아오면 원래 상태로 완전히 되돌린다 — 남은 transform 이 있으면 슬라이더가
 *    어긋난 채로 움직인다.
 */
(function () {
  if (window.__ntPinchZoom) return;
  window.__ntPinchZoom = true;

  var MAX = 4;      /* 그 이상은 픽셀이 뭉개진다 */
  var mq = window.matchMedia('(max-width: 1024px)');

  function dist(t1, t2) {
    var dx = t1.clientX - t2.clientX;
    var dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function setup(media) {
    if (media.dataset.ntPz === '1') return;
    var img = media.querySelector('img');
    if (!img) return;
    media.dataset.ntPz = '1';

    var scale = 1, x = 0, y = 0;
    var startScale = 1, startDist = 0, startX = 0, startY = 0;
    var midX = 0, midY = 0;
    var pinching = false, panning = false;

    function apply() {
      img.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(' + scale + ')';
    }

    /* 확대된 그림이 빈 칸을 드러내지 않도록 이동 범위를 가둔다. */
    function clamp() {
      var r = media.getBoundingClientRect();
      var maxX = 0, minX = r.width - r.width * scale;
      var maxY = 0, minY = r.height - r.height * scale;
      x = Math.min(maxX, Math.max(minX, x));
      y = Math.min(maxY, Math.max(minY, y));
    }

    function reset(animate) {
      scale = 1; x = 0; y = 0;
      if (animate) {
        img.classList.add('nt-pz-snap');
        setTimeout(function () { img.classList.remove('nt-pz-snap'); }, 260);
      }
      img.style.transform = '';
      media.classList.remove('nt-pz-on');
    }

    media.addEventListener('touchstart', function (e) {
      if (!mq.matches) return;

      if (e.touches.length === 2) {
        pinching = true; panning = false;
        media.classList.add('nt-pz-on');
        img.classList.remove('nt-pz-snap');
        startDist = dist(e.touches[0], e.touches[1]);
        startScale = scale;
        var r = media.getBoundingClientRect();
        midX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left;
        midY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top;
        startX = x; startY = y;
        e.preventDefault();
        e.stopPropagation();
      } else if (e.touches.length === 1 && scale > 1) {
        /* 확대돼 있을 때만 한 손가락 이동을 가져온다 — 아니면 슬라이더가 써야 한다. */
        panning = true;
        startX = e.touches[0].clientX - x;
        startY = e.touches[0].clientY - y;
        e.stopPropagation();
      }
    }, { passive: false });

    media.addEventListener('touchmove', function (e) {
      if (!mq.matches) return;

      if (pinching && e.touches.length === 2) {
        var ratio = dist(e.touches[0], e.touches[1]) / (startDist || 1);
        scale = Math.min(MAX, Math.max(1, startScale * ratio));
        /* ⚠️⚠️ **기준점은 '지금' 손가락 사이 지점이다(2026-09-09 지시 — 확대 중 시점 이동).**
           처음 잡은 지점(`midX`/`midY`)을 그대로 쓰면 배율만 따라가고 **시점은 첫 자리에
           고정**된다 — 두 손가락을 함께 옮겨도 그림이 안 움직였다.
           지금은 시작 시점의 그림 좌표 `(mid - start) / startScale` 를 **현재 중점 아래**에
           놓는다 → 배율이 그대로여도(ratio 1) 중점을 옮기면 그림이 따라온다.
           ⚠️ `(midX - startX)` 항을 지우지 말 것 — 그게 "처음 집은 그림 위치"다. 빼면
              확대할 때 그림이 흐른다(원래 그 항을 넣은 이유).
           ⚠️ 손을 떼면 여전히 원위치다(`end()` 의 `reset(true)`) — 앞선 지시가 그대로 유효하다. */
        var r2 = media.getBoundingClientRect();
        var curX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - r2.left;
        var curY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - r2.top;
        x = curX - (midX - startX) * (scale / startScale);
        y = curY - (midY - startY) * (scale / startScale);
        clamp();
        apply();
        e.preventDefault();
        e.stopPropagation();
      } else if (panning && e.touches.length === 1) {
        x = e.touches[0].clientX - startX;
        y = e.touches[0].clientY - startY;
        clamp();
        apply();
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });

    function end(e) {
      /* ⚠️⚠️ **손을 떼면 항상 원래 크기로 돌아간다(2026-09-09 지시).** 예전에는
         `scale < SNAP`(1.05) 일 때만 되돌리고 그 이상은 **확대를 유지**했다 — 제보:
         "확대하면 확대한 대로 이미지가 멈춰 있습니다".
         ⚠️ 그래서 `SNAP` 상수는 더 쓰지 않는다(값이 남아 있으면 되살릴 유혹이 생겨 지웠다).
         ⚠️ 확대가 유지되지 않으므로 **한 손가락 팬도 사실상 사라진다** — 확대 중에만
            가능했던 동작이고, 두 손가락을 떼는 순간 원위치로 돌아간다. 그게 요구사항이다.
         ⚠️ `reset(true)` 는 0.26s 애니메이션으로 되돌린다(`.nt-pz-snap`) — 즉시 튀지 않는다. */
      if (pinching && e.touches.length < 2) {
        pinching = false;
        reset(true);
      }
      if (panning && e.touches.length === 0) {
        panning = false;
        /* 팬만 하고 뗀 경우도 원위치 — 확대가 남아 있을 수 있다(예: 두 손가락 중 하나만 떼는 순서). */
        if (scale > 1) reset(true);
      }
    }

    media.addEventListener('touchend', end);
    media.addEventListener('touchcancel', end);

    /* iOS Safari — `touch-action` 만으로는 페이지 줌이 걸린다. */
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (t) {
      media.addEventListener(t, function (e) {
        if (mq.matches) e.preventDefault();
      });
    });

    /* 다른 슬라이드로 넘어가면 확대를 풀어 둔다 — 돌아왔을 때 확대된 채로 있으면 놀란다. */
    var slide = media.closest('.product__media-item');
    if (slide && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting && scale > 1) reset(false);
        });
      }, { threshold: 0.2 }).observe(slide);
    }
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper .product__media').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* 변형을 바꾸면 미디어가 다시 그려진다. */
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
